export const getTitle = (...parts) =>
    parts
        .concat(['PZH-CRM'])
        .filter((part) => !!part)
        .join(' | ');
